<esg-score-impact
	[metricsData]="carbonEmissionsTranslations"
	titleDcrKey="ESG_CARBON_SCORE_IMPACT_TITLE"
	subtitleDcrKey="ESG_CARBON_SCORE_IMPACT_SUBTITLE"
	disclosureDcrKey="ESG_CARBON_SCORE_IMPACT_DISCLOSURE"
	[asOfDate]="asOfDate"
></esg-score-impact>
